import * as yup from "yup";

export const loginSchema = yup.object({
  username: yup.string().email().required("Email is required"),
  password: yup.string().required("Password is required"),
});

export const forgotPasswordEmailSchema = yup.object({
  email: yup.string().email().required("Email is required"),
});

export const resetPasswordSchema = yup.object({
  oldPassword: yup.string().required("Old password is required"),
  newPassword: yup.string()
    .min(6, "New password must be at least 8 characters")
    .required("New password is required"),
  confirmnewpassword: yup.string()
    .oneOf([yup.ref("newPassword"), null], "Passwords must match")
    .required("Please confirm your new password"),
});
export const forgotPasswordResetSchema = yup.object({
  password: yup.string().min(8, "Password must be at least 8 characters").required("Password is required"),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password"), null], "Passwords must match")
    .required("Please confirm your password"),
})